import { render, staticRenderFns } from "./donation-tab.vue?vue&type=template&id=272ab440&scoped=true&"
import script from "./donation-tab.vue?vue&type=script&lang=js&"
export * from "./donation-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ab440",
  null
  
)

export default component.exports